import { render, staticRenderFns } from "./NewOrder.vue?vue&type=template&id=9138936c&scoped=true"
import script from "./NewOrder.vue?vue&type=script&lang=js"
export * from "./NewOrder.vue?vue&type=script&lang=js"
import style0 from "./NewOrder.vue?vue&type=style&index=0&id=9138936c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9138936c",
  null
  
)

export default component.exports